const data = [
  { id: 0, name: "Pendente" },
  { id: 1, name: "Aprovado" },
  { id: 2, name: "Rejeitado" },
  { id: 3, name: "Aprovado Parcial" },
  { id: 4, name: "Documentos Solicitados" },
  { id: 5, name: "Documentos Atualizados" },
  { id: 6, name: "Contraproposta Enviada" },
  { id: 7, name: "Contraproposta Retornada" },
];

export default [...data];